export default __webpack_public_path__ + "static/media/default-card-image-OG.d3d3aeab.jpg";